// shared/domain/permissions.js  (reglas de visibilidad puras; el backend sigue siendo la autoridad)
import ROLES from '../../../../constants/Roles';

export const canDelete = user => !!user && (user.id_rol === ROLES.ADMIN || user.id_rol === ROLES.ADMIN_COOP);
